import { render } from "./HeaderBase.vue?vue&type=template&id=0c228f3c&scoped=true"
import script from "./HeaderBase.vue?vue&type=script&lang=js"
export * from "./HeaderBase.vue?vue&type=script&lang=js"

import "./HeaderBase.vue?vue&type=style&index=0&id=0c228f3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c228f3c"]])

export default __exports__